exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/**\n  Footer\n */\n:host {\n  display: block;\n  height: 100px;\n  margin-top: -50px;\n  background-color: #222222; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/footer.component.scss
// module id = 385
// module chunks = 1